import { MainService } from './main.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  BehaviorSubject,
  catchError,
  combineLatestWith,
  distinctUntilChanged,
  filter,
  finalize,
  iif,
  map,
  mergeMap,
  Observable,
  of,
  shareReplay,
  switchMap,
  takeWhile,
  tap,
  throwError,
  timer,
} from 'rxjs';
import { AuthHttpService } from './auth-http.service';
import Swal from "sweetalert2";
import {error} from "@angular/compiler-cli/src/transformers/util";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
 token : any ;
  private authStatusSource = new BehaviorSubject<boolean>(false);
  public showTwoFactorCompomemt=new BehaviorSubject<boolean>(false);
  enablingSuccess=new BehaviorSubject<boolean>(false);

  // step : enable | confirm | challenge
  public TwoFactorStep=new BehaviorSubject<string>('enable')
  public is2fa_enabled=false;
  authStatus$ = this.authStatusSource.asObservable();
  constructor(
    private authHttpService: AuthHttpService,
    private router: Router,
    private mainService: MainService,
  ) {
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  // private fields
  private authLocalStorageToken = `token`;
  // public fields
  isLoading$: Observable<boolean>;

  isLoadingSubject = new BehaviorSubject<boolean>(false);

  // checkUser$: Observable<boolean> = this.authHttpService.checkUser().pipe(
  //   map((respone) => respone.data?.is_ready === true),
  //   catchError((error) => of(error))
  // );

  // isUserCheckd$: Observable<boolean> = this.checkUser$.pipe(
  //   filter((value :  any ) => !(value instanceof Error)),
  //   takeWhile((value) =>  value !== true, true), // stop making requests when true is received
  //   shareReplay(1) // cache the result of the HTTP request
  // );

  checkToken$: Observable<boolean> = this.authHttpService.checkToken().pipe(
    map((respone) => respone.data?.is_valid === true),
    catchError(() => of(false)),
    tap((val) => this.checkTokenSubject$.next(val))
  );

  // Use a BehaviorSubject to store the last emitted value of checkToken$
  private checkTokenSubject$ = new BehaviorSubject<boolean>(false);

  // Use a timer to periodically check the token validity
  private cachedTokenValidation$: Observable<boolean> = timer(0, 60e3).pipe(
    switchMap(() => this.checkToken$),
    takeWhile((v) => v !== false, true),
    mergeMap((v) => iif(() => v, of(v), this.logout())),
    shareReplay(1)
  );

  // Combine the two observables
  isUserLogged$: Observable<boolean> = this.checkTokenSubject$.pipe(
    distinctUntilChanged(),
    switchMap((v) =>
      iif(() => v, this.cachedTokenValidation$, this.checkToken$)
    ),
    tap((_isLogged) => {
      if (!_isLogged) {
        this.removeAuthFromLocalStorage();
      }
    })
  );

  // isUserLogged$: Observable<boolean> = this.mainService.MainStreamWrraper(
  // timer(0 ,  20e3).pipe(
  //   switchMap(() => this.checkToken$.pipe(
  //     tap((_isLogged) => {
  //       console.log('http checktoken');

  //       if (!_isLogged) this.removeAuthFromLocalStorage();
  //     }))),
  //   tap((v)=> console.log('cachedTokenValidation timer',v) ),
  //   shareReplay(1),

  // ), (action) => action.type == 'checkToken');

  isUserReady$: Observable<boolean> = this.isUserLogged$.pipe(
    // combineLatestWith(this.isUserLogged$),
    map(( isLogged: boolean) =>  isLogged)
  );

  getUserStats$:Observable<any> = this.authHttpService.userConnect().pipe(
    map((res)=> res?.data));
  getAssets$ : Observable<any> = this.authHttpService.getAsset().pipe(
    map((res)=>res?.data));


  // public methods
  login(email: string, password: string): Observable<any> {
    this.isLoadingSubject.next(true);
    return this.authHttpService.login(email, password).pipe(
      map((auth: any) => {
        const token = auth?.data?.token;
        if(auth?.data?._2fa_required){
          if(auth?.data?._2fa_enabled && auth?.data?._2f_confirmed) this.TwoFactorStep.next('challenge')
          else if(auth?.data?._2fa_enabled && !auth?.data?._2f_confirmed){
          this.enablingSuccess.next(true)
            this.TwoFactorStep.next('confirm')
          }else this.TwoFactorStep.next('enable')
          this.showTwoFactorCompomemt.next(true);
          this.is2fa_enabled=auth?.data?._2fa_required;
          this.authHttpService.token2FA=token;
          return false;
        }else{
          const result = this.setAuthFromLocalStorage(token);
          if(token)   this.authStatusSource.next(true);
              return result;

            }
        }
          ),
        // this.mainService.mainStreamsActions$.next({ type:'checkToken'});
      catchError((err) => {
        console.log('err', err.message);
        this.isLoadingSubject.next(false)
        return of(undefined);
      }),
      finalize(() => {
        console.log('success')
        // this.userService.getUserRole$
      } /*this.isLoadingSubject.next(false)*/)
    );
  }

  logout(): Observable<any> {
    this.isLoadingSubject.next(true);

    return this.authHttpService.logout().pipe(

      // finalize(() => {
      //   this.isLoadingSubject.next(false);
      //   this.removeAuthFromLocalStorage();
      //   // this.mainService.mainStreamsActions$.next({ type:'checkToken'});
      //   this.checkTokenSubject$.next(false);
      //   // this.router.navigate(['/login']);
      //   window.location.reload();
      // })
      tap((response) => {
        console.log(response);
        this.isLoadingSubject.next(false);
        this.removeAuthFromLocalStorage();
        // this.mainService.mainStreamsActions$.next({ type:'checkToken'});
        this.checkTokenSubject$.next(false);
        if(response?.data?.redirect ===true && response?.data?.url ) {
          window.location.href = response?.data?.url
        }else{
          window.location.reload();
        }

      }),
      catchError((error) => {
        console.error(error);
        // Effectuer les mêmes actions en cas d'erreur
        this.isLoadingSubject.next(false);
        this.removeAuthFromLocalStorage();
        this.checkTokenSubject$.next(false);
        window.location.reload();
        return throwError(error); // Propager l'erreur si nécessaire
      }),
    );
  }

  // need create new user then login
  signup(user: any): Observable<any> {
    this.isLoadingSubject.next(true);
    return this.authHttpService.createUser(user).pipe(
      map((resp) => {
        this.isLoadingSubject.next(false)
       return  resp.data
      } ),
      //resp.data?.is_created === true
      // switchMap((is_created: boolean) =>
      //   is_created
      //     ? this.login(user.email, user.password)
      //     : throwError(() => 'error user not created')
      // ),
      // catchError((err) => {
      //   console.error('err', err);
      //   this.isLoadingSubject.next(false);
      //   return of(err);
      // }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  forgotPassword(email: string): Observable<boolean> {
    this.isLoadingSubject.next(true);
    return this.authHttpService
      .forgotPassword(email)
      .pipe( map((email: any) => {
          const data = email
          console.log("service",data)
          return data;
        }),
        finalize(() => this.isLoadingSubject.next(false)))
      ;
  }

  resetPassword(token : string , password: string ): Observable<boolean>{
    this.isLoadingSubject.next(true);
    return  this.authHttpService.resetPassword(token, password).pipe(map((data : any)=>{
      console.log(data)
      return data;
    } ))
  }

  // private methods
  private setAuthFromLocalStorage(token: any): boolean {
    // store auth authToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    if (token) {
      localStorage.setItem(this.authLocalStorageToken, token);
      return true;
    }
    return false;
  }

  getAuthFromLocalStorage(): string | undefined {
    try {
      const token = localStorage.getItem(this.authLocalStorageToken);
      if (!token) {
        return undefined;
      }
      return token;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  removeAuthFromLocalStorage() {
    return localStorage.removeItem(this.authLocalStorageToken);
  }

  reloadApp() {
    console.log('reload');
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl('/');
    this.router.onSameUrlNavigation = 'ignore';
  }
  checkCode(code: any):Observable<boolean>{
    this.isLoadingSubject.next(true);
   return this.authHttpService.checkCode(code).pipe(
     map((codeToken : any)=>{
       this.token = codeToken?.data?.token;
       console.log(this.token)
       return codeToken
     }),

   )
  }


  setT2faEnable(){
    return this.authHttpService.setEnable2FA()
  }

  getQRCode(){
    return this.authHttpService.get2faQrCode();
  }

  getRecoveryCode(){
    return this.authHttpService.get2faRecovryCodes();
  }

  confirmCode(payload:any){
    return this.authHttpService.confirm2FA(payload).pipe(
      map(data=>{
        const token=data?.token;
        const result = this.setAuthFromLocalStorage(token);
        if(token){
           this.authStatusSource.next(true);
           this.reloadApp();
        }
        return result;
      }),
      );
  }
  verifySessionCode(payload:any,isRecovery_code:boolean){

    return this.authHttpService.confirm2faSessionCode(payload).pipe(
      map(data=>{
        const token=data?.token;
        if(isRecovery_code){
          this.enablingSuccess.next(true);
          this.TwoFactorStep.next('confirm');
          return false;
        }else{

          if(token){
             this.authStatusSource.next(true);
             this.reloadApp();
          }
          const result = this.setAuthFromLocalStorage(token);

          return result;
        }

      }),
      );
  }

}
